import { forwardRef, type SVGProps } from 'react';
import { AlertCircle, CheckCircle, XCircle } from 'lucide-react';

import { ErrorClass } from '@/platform-status/entities/platform-component';
import { errorClassTextColor } from '@/platform-status/utils/error-class';
import { cls } from '@/utils/cls';

export type PlatformComponentStatusIconProps = SVGProps<SVGSVGElement> & {
  activeErrorClass?: ErrorClass;
};

export const PlatformComponentStatusIcon = forwardRef<
  SVGSVGElement,
  PlatformComponentStatusIconProps
>(({ activeErrorClass, className, ...props }, ref) => {
  switch (activeErrorClass) {
    case undefined:
      return (
        <CheckCircle
          {...props}
          ref={ref}
          className={cls('size-5 text-primary-500', className)}
        />
      );
    case ErrorClass.ERROR_CLASS_2:
      return (
        <AlertCircle
          {...props}
          ref={ref}
          className={cls(
            'size-5',
            errorClassTextColor[activeErrorClass],
            className,
          )}
        />
      );
    case ErrorClass.ERROR_CLASS_1:
      return (
        <XCircle
          {...props}
          ref={ref}
          className={cls(
            'size-5',
            errorClassTextColor[activeErrorClass],
            className,
          )}
        />
      );
  }
});

PlatformComponentStatusIcon.displayName = 'PlatformComponentStatusIcon';
